import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import FormContext from './FormContext'
import FormSuspense from 'src/components/Forms/FormSuspense'
import Form from './Form'

interface AddModalProps {
  isOpen: boolean
  toggle: () => void
}

const AddModal: React.FC<AddModalProps> = (props) => {
  const { isOpen, toggle } = props

  return (
    <Modal
      title='Add Contract'
      isOpen={isOpen}
      toggle={toggle}
    >
      <Header title='Add Contract' />
      <FormSuspense fallback={<Form toggle={toggle} disableSave />}>
        <FormContext toggle={toggle} />
      </FormSuspense>
    </Modal>
  )
}

export default AddModal
